import React from "react";
import { useLanguage } from "@/context/LanguageContext";

const Offerings = () => {
  const { t } = useLanguage();
  return (
    <section
      id="courses"
      data-testid="courses-section"
      className="bg-[#f4f1ea] py-24 sm:py-32"
    >
      {/* SEO anchor aliases — additional landing-page targets for internal links */}
      <span id="aulas-de-frances" className="block -mt-24 pt-24" aria-hidden="true" />
      <span id="aulas-online" className="block -mt-24" aria-hidden="true" />
      <span id="curso-online-frances" className="block -mt-24" aria-hidden="true" />
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-12">
        <div className="max-w-2xl">
          <h2 className="overline">{t.offerings.seoH2}</h2>
          <p
            data-testid="courses-title"
            className="font-display mt-4 text-4xl sm:text-5xl tracking-tight text-[#1e2a5a]"
          >
            {t.offerings.title}
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-0 border-t border-l border-[#e5e3db]">
          {t.offerings.items.map((item, i) => (
            <article
              key={i}
              data-testid={`offering-card-${i}`}
              className="group relative border-b border-r border-[#e5e3db] bg-[#f4f1ea] p-8 sm:p-10 transition-all duration-500 hover:bg-white"
            >
              <span className="font-display text-xs tracking-[0.18em] text-[#d9381e]">
                {item.tag}
              </span>
              <h3 className="font-display mt-6 text-2xl text-[#1e2a5a]">
                {item.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-[#5c5c5c]">
                {item.body}
              </p>
              <span className="pointer-events-none absolute left-0 right-0 bottom-0 h-px bg-[#1e2a5a] origin-left scale-x-0 transition-transform duration-500 group-hover:scale-x-100" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Offerings;
